import { createIcon } from '@chakra-ui/react';

export const AuthorizeNetLogoIcon = createIcon({
  displayName: 'AuthorizeNetLogoIcon',
  path: (
    <svg width="100%" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
      <rect width="128" height="128" fill="#202A44" rx="16" />
      <circle cx="57" cy="55" r="40" fill="#2B6AFD" />
      <circle cx="100" cy="102" r="14" fill="#FFC301" />
    </svg>
  ),
});
